"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var react_waypoint_1 = __importDefault(require("react-waypoint"));
var ImpressionTracker = function (_a) {
    var children = _a.children, onImpression = _a.onImpression, triggerThreshold = _a.triggerThreshold;
    var impressionTimeout = null;
    var startCounter = function () {
        if (!impressionTimeout) {
            impressionTimeout = window.setTimeout(onImpression, triggerThreshold || 500);
        }
    };
    var stopCounter = function () {
        if (impressionTimeout) {
            window.clearTimeout(impressionTimeout);
            impressionTimeout = null;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(react_waypoint_1["default"], { onEnter: startCounter, onLeave: stopCounter }),
        children));
};
exports["default"] = ImpressionTracker;
